var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBackButtonSp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E2E3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8347 20.168C21.3347 20.168 21.0013 19.8346 21.0013 19.3346V16.0013C21.0013 15.5013 20.668 15.168 20.168 15.168H12.168L13.2513 16.2513C13.5847 16.5846 13.5847 17.0846 13.2513 17.418C12.918 17.7513 12.418 17.7513 12.0847 17.418L9.58466 14.918C9.25132 14.5846 9.25132 14.0846 9.58466 13.7513L12.0847 11.2513C12.2513 11.0846 12.418 11.0013 12.668 11.0013C12.918 11.0013 13.0847 11.0846 13.2513 11.2513C13.5847 11.5846 13.5847 12.0846 13.2513 12.418L12.168 13.5013H20.168C21.5847 13.5013 22.668 14.5846 22.668 16.0013V19.3346C22.668 19.8346 22.3347 20.168 21.8347 20.168Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBackButtonSp);
export default __webpack_public_path__ + "static/media/aiBackButtonSP.e218f0dc2d5d348804fb88324fd133bc.svg";
export { ForwardRef as ReactComponent };